var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
import { cn } from '~/utils';
// Generic types (TFieldValues) cannot be passed to context. Any has to be used instead.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormContext = createContext(null);
function Form(_a) {
    var { form, onSubmit, children, className } = _a, props = __rest(_a, ["form", "onSubmit", "children", "className"]);
    return (_jsx(FormContext.Provider, Object.assign({ value: { form } }, { children: _jsx("form", Object.assign({}, props, { className: cn('bf-form', className), onSubmit: form.handleSubmit(onSubmit) }, { children: children })) })));
}
export default Form;
